import React from 'react'
import {Router} from "@reach/router";
import ShippingOrderEditContainer from "./ShippingOrderEditContainer";
import ShippingOrder from "./ShippingOrder";
import {ShippingOrderProvider} from "../../context/ShippingOrderContext";


const ShippingOrderContainer = () => {

    return (
        <React.Fragment>
            <ShippingOrderProvider>
                <Router>
                    <ShippingOrder path={'/list'}/>
                    <ShippingOrderEditContainer path={'/edit/:shippingId'}/>
                </Router>
            </ShippingOrderProvider>
        </React.Fragment>
    )
}
export default ShippingOrderContainer